/**
 * Keyboard-grid column navigation for the cue table. Pure so the skip logic is
 * unit-testable: below 700px the Dur/CPS columns are `display: none`
 * (CueTable.css), and calling `.focus()` on a hidden element is a no-op — a
 * naive `col ± 1` move would silently drop keyboard focus there.
 */

/**
 * The next focusable column for a horizontal move from `col` in direction
 * `delta`, skipping columns whose cell is not visible. Returns `col` itself
 * when no visible column exists further in that direction (clamped at the
 * grid edge). With every column visible this is exactly the old clamped
 * `col ± 1` behaviour.
 */
export function nextVisibleCol(
  col: number,
  delta: 1 | -1,
  colCount: number,
  isVisible: (col: number) => boolean,
): number {
  for (let c = col + delta; c >= 0 && c < colCount; c += delta) {
    if (isVisible(c)) return c;
  }
  return col;
}
